<template>
  <div>
    <form @submit.prevent action>
      <div class="modal-card" style="width: 350px">
        <header class="modal-card-head">
          <p class="modal-card-title">Registrar Pagamento</p>
        </header>

        <section class="modal-card-body">
          <div v-if="!ativeLoader">
            <div style="text-align: justify">
              <p>
                Selecione a data e clique em 'Salvar' para registrar o pagamento da mensalidade de
                <strong>{{socio.nome}}</strong> para o mês de
                <strong>{{mes.nome}}</strong> de
                <strong>{{ano}}</strong>.
              </p>
            </div>
            <br>
            <b-field label="Data do Pagamento">
              <b-datepicker
                v-model="date"
                placeholder="Clique para selecionar..."
                icon="calendar-today"
                position="is-top-left"
                :month-names="monthNames"
                :day-names="dayNames"
              ></b-datepicker>
            </b-field>
          </div>

          <div v-if="ativeLoader" class="loading">
            <div class="loading-animation">
              <lottie :options="defaultOptions" :height="100" :width="100"/>
            </div>
            <p>Aguarde um instante...</p>
          </div>
        </section>

        <footer v-if="!ativeLoader" class="modal-card-foot" style="display: block;">
          <button
            class="button is-small is-success"
            style="float: left;"
            @click="salvarInformacaoPgto"
          >SALVAR</button>
          <button
            class="button is-small is-danger"
            style="float: right;"
            @click="closeModal"
          >CANCELAR</button>
        </footer>
      </div>
    </form>
  </div>
</template>

<script>
import Lottie from "vue-lottie";
import * as animationData from "@/assets/loading-animation.json";

export default {
  props: ["socio", "mes", "ano"],
  components: {
    lottie: Lottie
  },
  data() {
    return {
      defaultOptions: { animationData: animationData.default },
      ativeLoader: false,
      date: null,
      idAssociacao: this.$cookies.get("IDASSOCIACAO"),
      transacao: {
        _id: "",
        _associacao: this.$cookies.get("IDASSOCIACAO"),
        _conta: "",
        _responsavel: this.$cookies.get("USERTOKEN"),
        data: "",
        valor: 0.0,
        tipo: "",
        descricao: "",
        allowedErase: false,
        isAdjust: false
      },
      monthNames: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro"
      ],
      dayNames: ["D", "S", "T", "Q", "Q", "S", "S"]
    };
  },

  computed: {
    successAddTransacao() {
      return this.$store.getters["transacao/getIsSuccess"];
    },

    successChangeSocioMensalidade() {
      return this.$store.getters["associados/getIsSuccess"];
    }
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },

    async salvarInformacaoPgto() {
      if (!this.date) {
        this.$alert("Erro!", "Data não Informada!", "danger");
        return;
      }

      this.ativeLoader = true;
      this.transacao._id = this.stringRandomId(20);
      this.transacao._conta = this.$store.getters["contas/getContas"].filter(conta => {
        return conta.isDefault;
      })[0]._id;
      this.transacao.data = this.date;
      this.transacao.valor = this.$store.getters[
        "associacao/getAssociacao"
      ].valor_mensalidade;
      this.transacao.tipo = "Mensalidade";
      this.transacao.descricao = `Pgto Mensalidade de ${this.socio.nome} / ${
        this.mes.nome
      } de ${this.ano}`;

      this.mes.pago = true;
      this.mes.data_pagamento = this.date.toISOString();
      this.mes._transacao = this.transacao._id;

      //Salvar Transação
      await this.$store.dispatch(
        "transacao/saveTransacaoInFirestore",
        this.transacao
      );
      //Atualiza a conta
      if (this.successAddTransacao) {
        this.$store.dispatch("transacao/getTransacoesInFirestore");
        this.$alert("Sucesso!", "Transação Adicionada!", "success");
        this.$store.commit("transacao/setIsSuccess", false);
        await this.$store.dispatch(
          "associados/saveMensalidadeSocioInFirestore",
          {
            socio: this.socio,
            mes: this.mes,
            ano: this.ano,
            del: false
          }
        );
      } else {
        this.$alert("Erro!", "Erro ao Salvar Transação!", "danger");
      }

      //Notificar usuário da atualização
      if (this.successChangeSocioMensalidade) {
        this.$alert("Sucesso!", "Informação do Usuário Atualizado!", "success");
        this.$store.commit("associados/setIsSuccess", false);
      } else {
        this.$alert(
          "Erro!",
          "Erro ao Atualizar Informações do Usuário!",
          "danger"
        );
      }
      this.$store.commit("associacao/setRequireUpdate", true);
      this.$store.dispatch("associacao/getAssociacaoInFirestore");
      this.closeModal();
    },

    stringRandomId(tamanho) {
      let letras = "ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";
      let aleatorio = "";
      for (var i = 0; i < tamanho; i++) {
        var rnum = Math.floor(Math.random() * letras.length);
        aleatorio += letras.substring(rnum, rnum + 1);
      }
      return aleatorio;
    }
  }
};
</script>

<style scoped>
.modal .animation-content .modal-card {
  overflow: visible !important;
}

.modal-card-body {
  overflow: visible !important;
}

@media screen and (max-width: 1088px) {
  .modal .animation-content .modal-card {
    overflow: scroll !important;
  }
}
.loading {
  text-align: center;
}
</style>